import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { StickyContainer, Sticky } from 'react-sticky';
import _throttle from 'lodash/throttle';
import { Link } from '@zola/zola-ui';
import Helmet from 'react-helmet';
import moment from 'moment';

// actions
import { fetchBannerList, updateWebsiteVisibility } from '../actions/PublicWebsiteActions';

// components
import PublicHeader from '../components/PublicWebsite/PublicHeader';
import HeaderCart from '../components/PublicWebsite/HeaderCart';
import PublicFooter from '../components/PublicWebsite/PublicFooter';
import { showModal } from '../actions/ModalActions';
import { getCartSize } from '../actions/CartActions';
// import { updateWebsiteVisibility } from '../actions/PublicWebsiteActions';
import UnifiedNav from '../components/common/header/UnifiedNav';
import UpdateBanner from '../components/PublicWebsite/UpdateBanner/UpdateBanner';
import FeatureFlags from '../util/featureFlags';

import '../stylesheets/pages/Public.less';

const WEB_NAV_CART_MODAL = FeatureFlags.get('publicWebNavCartModal');
const enableBannerFeature = FeatureFlags.get('websitePSA');
const collapsibleNav = FeatureFlags.get('collapsibleNav');

class PublicWebsite extends Component {
  constructor(props) {
    super(props);

    this.state = {
      viewport:
        this.props.location.query.viewport && this.props.location.query.viewport.toUpperCase(),
      // bannerPreviewId: null,
    };

    this.addModalListener = this.addModalListener.bind(this);
    this.onCartSize = props.onCartSize.bind(this);
  }

  componentWillMount() {
    const { pages } = this.props;
    const htmlEl = document.getElementsByTagName('html')[0];
    htmlEl.setAttribute('id', 'public-wedding-background');
    htmlEl.className = htmlEl.className
      ? htmlEl.className.replace(/ public-wedding-page/g, '')
      : htmlEl.className;
    htmlEl.className = `${htmlEl.className} public-wedding-page`;

    const handleScroll = () => {
      if (!collapsibleNav) return;
      const weddingDetails = document.getElementById('public-page-details');
      const weddingTitle = document.getElementById('public-page-title');
      const weddingHeader = document.getElementById('public-page-header');
      const stickyNav = document.querySelector('.sticky-nav');
      if (window.scrollY > 5 && weddingDetails) {
        // for websites with no other pages we will hide the entire nav
        // when user scrolls down. if there are pages then we will shorten it
        if (pages.length === 0) {
          weddingHeader.classList.add('isHidden');
          stickyNav.classList.add('isHidden');
        } else {
          weddingDetails.classList.add('isHidden');
          weddingTitle.classList.add('isHidden');
        }
      } else if (window.scrollY <= 5 && weddingDetails) {
        if (pages.length === 0) {
          weddingHeader.classList.remove('isHidden');
          stickyNav.classList.remove('isHidden');
        }
        weddingDetails.classList.remove('isHidden');
        weddingTitle.classList.remove('isHidden');
      }
    };
    window.addEventListener('scroll', _throttle(handleScroll, 250));
  }

  componentDidMount() {
    const {
      // getBannerList,
      onCartSize,
      // location
    } = this.props;

    onCartSize();
    if (WEB_NAV_CART_MODAL) this.addModalListener();
  }

  componentWillUnmount() {
    const htmlEl = document.getElementsByTagName('html')[0];
    htmlEl.removeAttribute('id');
    htmlEl.className = htmlEl.className.replace(/ public-wedding-page/g, '');
  }

  addModalListener() {
    // Listen for web-nav cart events to update web-wedding
    window.addEventListener('CART_MODAL_REMOVE_ITEM', () => {
      // handle the delay from when web-nav updates and web-wedding calls for an update
      setTimeout(() => {
        this.onCartSize();
      }, 300);
    });
  }

  formatLocation(city, state) {
    if (city && state) return `${city}, ${state}`;
    if (city) return city;
    if (state) return state;
    return undefined;
  }

  render() {
    const {
      children,
      pages,
      theme,
      wedding,
      page,
      onLogin,
      onToggleWebsitePublish,
      busy,
      hideBannerForMobileSnapShot,
      hideNavForMobileSnapShot,
      onCart,
      cartSize,
      userInfo,
      location,
    } = this.props;

    const { viewport } = this.state;
    const weddingDate = moment.utc(wedding.wedding_date).isValid()
      ? moment.utc(wedding.wedding_date).format('MMMM D, YYYY')
      : undefined;
    const viewportContent =
      viewport === 'DESKTOP' ? 'width=1200' : 'width=device-width, initial-scale=1.0';

    const cloudfront =
      window.location.hostname === 'localhost' || window.location.hostname === 'qa.zola.com'
        ? 'https://d2wzwlp3rxwsn1.cloudfront.net'
        : 'https://d2gt2lt628wbyx.cloudfront.net';
    const metaConf = [
      {
        name: 'viewport',
        content: viewportContent,
      },
      {
        name: 'keywords',
        content: `wedding website, ${wedding.owner_first_name} ${wedding.owner_last_name}, ${wedding.partner_first_name} ${wedding.partner_last_name}, ${wedding.owner_first_name} and ${wedding.partner_first_name}`,
      },
      {
        name: 'description',
        content: `The wedding website of ${wedding.owner_first_name} ${wedding.owner_last_name} and ${wedding.partner_first_name} ${wedding.partner_last_name}`,
      },
    ];

    if (!wedding.enable_search_engine) {
      metaConf.push({
        name: 'robots',
        content: 'noindex',
      });
    }

    // banner text handling & logic
    const { query } = location;
    const { cms_banner_message: bannerText } = wedding;
    const { enable_cms_banner: bannerCMSEnabled, wedding_account_id: siteWeddingId } = wedding;
    const { has_wedding_account: hasWeddingAccount, wedding_account: userWedding } = userInfo;
    const isCouple = hasWeddingAccount && siteWeddingId === userWedding.id;
    const showPreview = isCouple && query.infoPreview === 'true';
    const isMobilePreview = query.disable_nav === 'true';
    const showBanner = enableBannerFeature && !isMobilePreview && (bannerCMSEnabled || showPreview);

    return (
      <StickyContainer>
        {WEB_NAV_CART_MODAL && <UnifiedNav isHidden />}
        <Helmet
          link={[
            {
              rel: 'stylesheet',
              href: theme.font_name && `https://fonts.googleapis.com/css?family=${theme.font_name}`,
            },
            {
              rel: 'stylesheet',
              href: `${cloudfront}/${theme.key}.css`,
            },
          ]}
          meta={metaConf}
          defaultTitle={`${wedding.owner_first_name} ${wedding.owner_last_name} and ${wedding.partner_first_name} ${wedding.partner_last_name}'s Wedding Website`}
        />
        <div id="public-wrapper">
          <HeaderCart cartSize={cartSize} onCart={onCart} classNames="noMobile" />
          <Sticky className="sticky-nav" stickyStyle={{ zIndex: 100 }} topOffset={20}>
            {!wedding.wedding_published && !hideBannerForMobileSnapShot && (
              <div id="publish-website-banner">
                <div className="banner-content">
                  <p>
                    Your website is currently hidden
                    <span className="hidden-sm hidden-xs">
                      , and is not visible to guests
                    </span>.{' '}
                    <Link
                      role="button"
                      className="hidden-xs publish-website-banner__link"
                      onClick={() => onToggleWebsitePublish(wedding.wedding_published)}
                    >
                      Make it visible
                    </Link>
                  </p>
                  <Link
                    className="visible-xs text-center publish-website-banner__link"
                    role="button"
                    onClick={() => onToggleWebsitePublish(wedding.wedding_published)}
                  >
                    Make it visible
                  </Link>
                </div>
              </div>
            )}
            {showBanner && bannerText !== null && <UpdateBanner text={bannerText} />}
            {!hideNavForMobileSnapShot ? (
              <Fragment>
                <PublicHeader
                  name={wedding.title}
                  hashtag={wedding.hashtag}
                  weddingDate={weddingDate}
                  location={this.formatLocation(wedding.city, wedding.state_province)}
                  slug={wedding.slug}
                  onCart={onCart}
                  cartSize={cartSize}
                  pages={pages}
                />
              </Fragment>
            ) : null}
          </Sticky>
          <div id="public-page-content-wrapper" className={busy ? 'hide-page' : 'show-page'}>
            <div>{children}</div>
            {wedding.owner_first_name &&
              wedding.partner_first_name &&
              page &&
              page.type !== 'HOME' &&
              wedding.enable_seal &&
              !busy && (
                <div className="container seal">
                  <div className="seal-section">
                    <span className="name-1">
                      {wedding.owner_first_name && (
                        <span className="initial-1">{wedding.owner_first_name[0]}</span>
                      )}
                      {wedding.owner_last_name && (
                        <span className="initial-2">{wedding.owner_last_name[0]}</span>
                      )}
                    </span>
                    {wedding.owner_first_name && wedding.partner_first_name && (
                      <span>
                        <span className="amp">&amp;</span>
                        <span className="and">and</span>
                        <span className="plus">+</span>
                      </span>
                    )}
                    <span className="name-2">
                      {wedding.partner_first_name && (
                        <span className="initial-1">{wedding.partner_first_name[0]}</span>
                      )}
                      {wedding.partner_last_name && (
                        <span className="initial-2">{wedding.partner_last_name[0]}</span>
                      )}
                    </span>
                  </div>
                </div>
              )}
          </div>
          <PublicFooter page={page} onLogin={onLogin} partnerName={theme.partner_name} />
        </div>
      </StickyContainer>
    );
  }
}

PublicWebsite.propTypes = {
  children: PropTypes.element.isRequired,
  theme: PropTypes.shape({
    font_name: PropTypes.string,
    key: PropTypes.string,
    partner_name: PropTypes.string,
  }),
  wedding: PropTypes.shape({
    wedding_date: PropTypes.string,
    owner_first_name: PropTypes.string,
    owner_last_name: PropTypes.string,
    partner_first_name: PropTypes.string,
    partner_last_name: PropTypes.string,
    enable_search_engine: PropTypes.bool,
    wedding_published: PropTypes.bool,
    title: PropTypes.string,
    hashtag: PropTypes.string,
    city: PropTypes.string,
    state_province: PropTypes.string,
    slug: PropTypes.string,
    enable_seal: PropTypes.bool,
  }),
  pages: PropTypes.arrayOf(PropTypes.shape({})),
  page: PropTypes.shape({ type: PropTypes.string }),
  busy: PropTypes.bool,
  onLogin: PropTypes.func.isRequired,
  onCart: PropTypes.func.isRequired,
  onCartSize: PropTypes.func.isRequired,
  cartSize: PropTypes.number,
  onToggleWebsitePublish: PropTypes.func.isRequired,
  location: PropTypes.shape({
    query: PropTypes.shape({
      viewport: PropTypes.string,
      infoPreview: PropTypes.string,
      disable_nav: PropTypes.string,
    }),
  }),
  hideBannerForMobileSnapShot: PropTypes.bool,
  hideNavForMobileSnapShot: PropTypes.bool,
  userInfo: PropTypes.shape({
    has_wedding_account: PropTypes.bool,
    wedding_account_id: PropTypes.number,
  }),
};

const mapStateToProps = state => ({
  cartSize: state.cart.size,
  wedding: state.publicWebsite.wedding,
  pages: state.publicWebsite.pages,
  theme: state.publicWebsite.theme,
  page: state.publicWebsite.page,
  busy: state.publicWebsite.busy,
  hideBannerForMobileSnapShot:
    state.routing.locationBeforeTransitions.query.disable_banners === 'true',
  hideNavForMobileSnapShot: state.routing.locationBeforeTransitions.query.disable_nav === 'true',
  bannerList: state.publicWebsite.cmsBanners,
  userInfo: state.user.userContext,
});

const mapDispatchToProps = dispatch => ({
  onLogin: () => dispatch(showModal('AUTH')),
  onCart: () => dispatch(showModal('CART_MODAL')),
  onCartSize: () => dispatch(getCartSize()),
  onToggleWebsitePublish: makeVisible => {
    dispatch(updateWebsiteVisibility(!makeVisible));
    if (!makeVisible) {
      dispatch(showModal('PUBLISH_WEBSITE', {}, { size: 'md' }));
    }
  },
  getBannerList: () => dispatch(fetchBannerList()),
});

const PublicWebsiteContainer = connect(mapStateToProps, mapDispatchToProps)(PublicWebsite);

export default PublicWebsiteContainer;



// WEBPACK FOOTER //
// ./src/pages/Public.jsx